@let reviewForm = form();

@if (reviewForm.invalid && reviewForm.touched) {
  <div class="mt-6">
    <div class="space-y-2">
      @if (reviewForm.errors?.commentsRequired) {
        <app-pan-inline-alert type="danger" class="mb-2"> Comments are required</app-pan-inline-alert>
      }
      @if (reviewForm.errors?.theftTypeRequired) {
        <app-pan-inline-alert type="danger" class="mb-2"> At least one incident type must be selected</app-pan-inline-alert>
      }
      @if (reviewForm.errors?.instancePhotoRequired) {
        <app-pan-inline-alert type="danger" class="mb-2"> At least one incident photo is required</app-pan-inline-alert>
      }
      @if (reviewForm.errors?.extraLinksRequired) {
        <app-pan-inline-alert type="danger" class="mb-2"> At least one additional link is required</app-pan-inline-alert>
      }
      @if (reviewForm.errors?.instanceAtRequired) {
        <app-pan-inline-alert type="danger" class="mb-2"> Incident date is required</app-pan-inline-alert>
      }
    </div>
  </div>
}

